export const containerStyles = {
    backgroundColor: '#F1F2F6',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '@media (max-width: 600px)': {
      padding: '0 16px', // Add padding on small screens
    },
  };
  
  export const boxLogoStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    bgcolor: 'inherit',
    color: 'black',
    flexDirection: 'column',
    '@media (max-width: 600px)': {
      flex: 'none',
      marginBottom: '16px',
    },
  };
  
  export const boxFormStyles = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left', 
    justifyContent: 'center',
    backgroundColor: '#FFFFFF',
    maxWidth: 'sm',
    height: '400px',
    borderRadius: '10px',
    margin: 8,
    boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.1)',
    flex: 2,
    p: 4,
    '@media (max-width: 600px)': {
      maxWidth: '100%',
      height: 'auto',
      margin: '16px 0',
      padding: '16px',
    },
  };
  
  export const textFieldStyles = {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'grey', // Default state border color
      },
      '&:hover fieldset': {
        borderColor: 'green', // Hover state border color
      },
      '&.Mui-focused fieldset': {
        borderColor: '#39B54A', // Focus state border color
      },
    },
    '& .MuiInputLabel-root': {
      color: 'grey', // Default state label color
      '&.Mui-focused': {
        color: '#39B54A', // Focus state label color
      },
    },
    '@media (max-width: 600px)': {
      width: '100%', // Full width on small screens
    },
  };
  
  export const buttonStyles = {
    mt: 3,
    backgroundColor: '#39B54A',
    '&:hover': {
      backgroundColor: '#2e8b3a',
    },
    '@media (max-width: 600px)': {
      width: '100%', // Full width on small screens
    },
  };
  